import { Layout } from 'antd';
import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import App from '@pages';
import Sidebar from '../Sidebar';
import Topbar from '../Topbar';

const { Content } = Layout;

const MainApp = () => {
  const match = useRouteMatch();

  return (
    <Layout className="gx-app-layout">
      <Sidebar />
      <Layout>
        <Topbar />
        <Content
          className={'gx-layout-content gx-container-wrap '}
          id="body-content"
        >
          <App match={match} />
        </Content>
      </Layout>
    </Layout>
  );
};
export default MainApp;
